import React from 'react';
import PropTypes from 'prop-types';

const path =
  'M33.5 11.6c.5 1.3 1 2.7 1.2 4.2.171.771.27 1.543.294 2.377L35 18.6l-.011.6c-.029.8-.109 1.6-.189' +
  ' 2.4-.2.9-.4 1.8-.7 2.7-2.4 6.9-8.9 11.9-16.6 11.9-7.7 0-14.3-5-16.6-11.9-.6-1.8-.9-3.6-.9-5.6 0-2.5.5-4.9 ' +
  '1.4-7 .4.2.8.3 1.3.3.3 0 .6-.1.9-.2-1 2.1-1.6 4.4-1.6 6.8 0 2 .4 3.9 1.1 5.6.8 2 2 3.8 3.5 5.3 2.8 2.8 6.6-' +
  '.6 10.9-.6 4.2 0 8.1 3.4 10.9.6 1.5-1.5 2.7-3.3 3.5-5.3.7-1.7 1.1-3.6 1.1-5.6 0-2.4-.6-4.7-1.6-6.7.2.1.4.1.' +
  '6.1.5 0 1.1-.1 1.5-.4Zm-16.1 5.7c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5-3.5-1.6-3.5-3.5 1.5-3.5 3.5-3.5Zm9.' +
  '187-5.909.313.209 1.5 1.2c.277.37.383.824.084 1.206l-.084.094-1.9 1.8c-.3.3-.8.3-1.1 0-4.5-3.9-11.3-3.9-15.' +
  '9 0-.273.273-.793.298-1.111.074L8.3 15.9l-1.9-1.8c-.4-.4-.4-1 0-1.3.5-.5 1-.8 1.5-1.2 5.596-3.83 13.024-3.8' +
  '99 18.687-.209ZM17.4 0c6.1 0 12.3 2.3 17.1 6.7.3.3.4.9 0 1.2l-1.9 1.8c-.3.3-.9.3-1.2 0-7.9-7.3-20.2-7.3-28.' +
  '1 0-.3.3-.9.3-1.2 0L.3 7.9c-.2-.1-.3-.4-.3-.6 0-.2.1-.4.3-.6C5.1 2.2 11.3 0 17.4 0Z';

const MySmartMeter = ({ colour, ...props }) => (
  <svg width={35} height={37} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{'My Smart Meter'}</title>
    <path d={path} fill={colour} fillRule="nonzero" />
  </svg>
);

MySmartMeter.propTypes = {
  colour: PropTypes.string.isRequired,
};

export default MySmartMeter;
